//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
// defrag daily results card imports
import { IProps, IState, IContainer } from "./ChromeStoreReviewDialog.d";
import * as s from "./ChromeStoreReviewDialog.styles";
// other components
import { SidebarDialog } from "@clockwise/web-commons/src/components/sidebar-dialog";
import { P, H2, EM } from "@ui";
// util
import { track, TrackingEvents } from "@util/analytics.util";
import { ZonedMoment } from "@util/time-zone.util";
// state
import { chromeWebstoreReviewResponseDate } from "@state/local-storage";
import { snackBarOpen } from "@actions/snack-bar.actions";
import { IReduxState } from "@state/reducers/root.reducer";
// material-ui
import { Button, DialogActions, DialogContent } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import { isChrome } from "@clockwise/web-commons/src/util/browser.util";

//////////////////
// COMPONENT
//////////////////
class ChromeStoreReviewDialogComponent extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      reviewStarted: false,
    };
  }

  // ~-~-~-~-~-~-~-
  // Helpers
  // ~-~-~-~-~-~-~-

  private closeDialog = () => {
    chromeWebstoreReviewResponseDate.set(new ZonedMoment());

    track(TrackingEvents.CHROME_EXTENSION.REVIEW_DECLINE);
    this.props.onClose();
  };

  private startReview = () => {
    chromeWebstoreReviewResponseDate.set(new ZonedMoment());

    const config =
      "width=820,height=500,top=200,left=300,toolbar=no,titlebar=no,status=no,location=no";
    window.open(
      "https://chrome.google.com/webstore/detail/clockwise/hjcneejoopafkkibfbcaeoldpjjiamog?hl=en-US&gl=US",
      "_blank",
      config,
    );
    track(TrackingEvents.CHROME_EXTENSION.REVIEW_START);
    this.setState({ reviewStarted: true });
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-

  private renderAskActions = () => {
    return [
      <Button variant="text" onClick={() => this.closeDialog()}>
        Not Now
      </Button>,
      <Button variant="text" onClick={() => this.startReview()} color="primary">
        Review Clockwise
      </Button>,
    ];
  };

  private renderAsk = () => {
    return (
      <div>
        <div>
          <H2 style={s.header}>Will you rate us on the Chrome Web Store?</H2>
        </div>
        <P>
          Enjoying Clockwise? Help others learn about Clockwise by leaving a quick rating and
          optional review on the Chrome Web Store. Thank you!
        </P>
        <P>– The Clockwise Team</P>
      </div>
    );
  };

  private renderReviewStartedActions = () => {
    return [
      <Button variant="text" onClick={() => this.props.onClose()} color="primary">
        Done
      </Button>,
    ];
  };

  private renderReviewStarted = () => {
    return (
      <div>
        <div>
          <H2 style={s.header}>Opening the review window...</H2>
        </div>
        <div>
          <P>How to review Clockwise:</P>
          <P>
            1. Click the <EM>Reviews</EM> tab.
          </P>
          <P>
            2. Click the <EM>Write a review</EM> button.
          </P>
          <P>3. Fill out your review.</P>
          <P>
            4. Final step: click <EM>Publish</EM>.
          </P>
          <P>Thank you!</P>
          <P>- The Clockwise Team</P>
        </div>
      </div>
    );
  };

  public render() {
    const { reviewStarted } = this.state;
    return (
      <SidebarDialog
        open={this.props.open}
        onClose={() => this.closeDialog()}
        isChromeExtension={this.props.isChromeExtension}
      >
        <DialogContent>
          {!reviewStarted ? this.renderAsk() : this.renderReviewStarted()}
        </DialogContent>
        <DialogActions>
          {!reviewStarted ? this.renderAskActions() : this.renderReviewStartedActions()}
        </DialogActions>
      </SidebarDialog>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
const ChromeStoreReviewDialogStyled = withStyles(s.styles)(ChromeStoreReviewDialogComponent);

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    // TODO: Make this component browser-agnostic, if possible
    // That is, try to prompt FF users to review our extension through a popup
    isChromeExtension: state.webExtension.isWebExtension && isChrome,
  };
}

export const ChromeStoreReviewDialog = connect(mapStateToProps, {
  snackBarOpen,
})(ChromeStoreReviewDialogStyled);
